<img class="full-width" src="{{sideSrc}}" alt="side icon"/>
